<template>
  <div>
    <div class="d-flex align-center mb-4">
      <v-text-field v-model="file" outlined prepend-inner-icon="mdi-file" disabled hide-details></v-text-field>
      <v-btn color="primary" @click="cancelChooseFile" text>Chọn tệp khác</v-btn>
    </div>
    <v-card>
      <v-data-table
        mobile-breakpoint="0"
        item-key="studentCode"
        :headers="headersPreview"
        :items="data"
        :footer-props="{
          'items-per-page-text': 'Hiển thị mỗi trang',
          'items-per-page-all-text': 'Tất cả'
        }"
        disable-sort
      >
        <template v-slot:[`item.stt`]="{ item }">
          <div v-if="item.stt !== null">{{ item.stt }}</div>
          <div v-else class="text--error">Thiếu dữ liệu</div>
        </template>
        <template v-slot:[`item.driver`]="{ item }">
          <div v-if="item.driver !== null">{{ item.driver }}</div>
          <div v-else class="text--error">Thiếu dữ liệu</div></template
        >
        <template v-slot:[`item.carRegistrationAt`]="{ item }">
          <div v-if="item.carRegistrationAt != null">{{ item.carRegistrationAt }}</div>
          <div v-else class="text--error">Thiếu dữ liệu</div></template
        >
        <template v-slot:[`item.driverLicenseAt`]="{ item }">
          <div v-if="item.driverLicenseAt != null">{{ item.driverLicenseAt }}</div>
          <div v-else class="text--error">Thiếu dữ liệu</div></template
        >
        <template v-slot:[`item.cccd`]="{ item }">
          <div v-if="item.cccd != null">{{ item.cccd }}</div>
          <div v-else class="text--error">Thiếu dữ liệu</div></template
        >
        <template v-slot:[`item.certificateTransportDriverAt`]="{ item }">
          <div v-if="item.certificateTransportDriverAt != null">{{ item.certificateTransportDriverAt }}</div>
          <div v-else class="text--error">Thiếu dữ liệu</div></template
        >
        <template v-slot:[`item.inspectionAt`]="{ item }">
          <div v-if="item.inspectionAt != null">{{ item.inspectionAt }}</div>
          <div v-else class="text--error">Thiếu dữ liệu</div></template
        >
        <template v-slot:[`item.insuranceCertificateAt`]="{ item }">
          <div v-if="item.insuranceCertificateAt != null">{{ item.insuranceCertificateAt }}</div>
          <div v-else class="text--error">Thiếu dữ liệu</div></template
        >
        <template v-slot:[`item.certificateHouseholdAt`]="{ item }">
          <div v-if="item.certificateHouseholdAt != null">{{ item.certificateHouseholdAt }}</div>
          <div v-else class="text--error">Thiếu dữ liệu</div></template
        >
        <template v-slot:[`item.motorLicenseAt`]="{ item }">
          <div v-if="item.motorLicenseAt != null">{{ item.motorLicenseAt }}</div>
          <div v-else class="text--error">Thiếu dữ liệu</div></template
        >
        <template v-slot:[`item.resume`]="{ item }">
          <div v-if="item.resume != null">{{ item.resume }}</div>
          <div v-else class="text--error">Thiếu dữ liệu</div></template
        >
        <template v-slot:[`item.healthCertificate`]="{ item }">
          <div v-if="item.healthCertificate != null">{{ item.healthCertificate }}</div>
          <div v-else class="text--error">Thiếu dữ liệu</div></template
        >
        <template v-slot:[`item.licensePlate`]="{ item }">
          <div v-if="item.licensePlate != null">{{ item.licensePlate }}</div>
          <div v-else class="text--error">Thiếu dữ liệu</div></template
        >
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
import { headers } from '../helper'

export default {
  props: {
    data: {
      type: Array
    },
    file: String
  },
  computed: {
    headersPreview() {
      const clone = [...headers]
      clone.pop()
      return clone
    }
  },
  data() {
    return {
      options: {}
    }
  },
  methods: {
    cancelChooseFile() {
      this.$emit('cancelChooseFile')
    }
  }
}
</script>
<style scoped>
.previewFile {
  position: absolute;
  top: 2.1%;
  left: 1.5%;
  color: #0d47a1;
}
.text--error {
  color: #ff0000 !important;
}
</style>
